// extracted by mini-css-extract-plugin
export default {"root":"QuestionPreview_root__qsH9f","preview":"QuestionPreview_preview__-jYTC","list":"QuestionPreview_list__5mkyj"};